import { CrossSellingPointer } from "../../others/crossSellingPointer.js";
import { RML } from "../names.js";
const crossRmlInsertDialog = ()=>CrossSellingPointer.waitForVisibleElement('body > div > .media-modal.wp-core-ui .media-frame-router button[role="tab"]:eq(1).active', RML, "insert-dialog");
export { crossRmlInsertDialog };
